import { Component, Input, NgModule } from '@angular/core';

@Component({
  selector: 'app-system-tooltip',
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {
  @Input({
    required: true,
  })
  selector = '';
  constructor() {}
}

@NgModule({
  declarations: [TooltipComponent],
  exports: [TooltipComponent],
})
export class SystemTooltipModule {}
